import React from 'react';
import { TestimonialManager } from '../../components/admin/TestimonialManager';

const Testimonials: React.FC = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-primary-900">Testimonials</h1>
        <p className="text-primary-600 mt-2">
          Manage client testimonials displayed on the homepage.
        </p>
      </div>
      
      <TestimonialManager />
    </div>
  );
};

export default Testimonials; 